// Narrative chapters (chronological order tab) and calendar months, FR/EN.
export const ROMANS = ['I', 'II', 'III', 'IV'] as const;
export const SEC_FR = ['Avant les Avengers', "Saga de l'Infini", 'Saga du Multivers', 'Phase 6 et au-delà'];
export const SEC_EN = ['Before the Avengers', 'The Infinity Saga', 'The Multiverse Saga', 'Phase 6 and Beyond'];
export const MONTHS_FR = [
  'jan.',
  'fév.',
  'mars',
  'avr.',
  'mai',
  'juin',
  'juil.',
  'août',
  'sep.',
  'oct.',
  'nov.',
  'déc.',
];
export const MONTHS_EN = ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'];

// Countdown target: Avengers: Doomsday, Dec 18 2026, 8pm.
export const DOOMSDAY_DATE = new Date('2026-12-18T20:00:00.000Z');
